import React from 'react';
import { getImageUrl } from '../../../configs/configs';
import { Button } from 'react-bootstrap';

export default function SelectedItem(props) {
    const { item } = props;
    const title = item.title.substr(0, 50);
    return (
        <div className="main-item p-2 mb-2">
            <div className="d-flex">
                <div>
                    <p className='tile pr-1'>{title}...</p>
                    {item.TTPNumber && <span className="py-1 px-2 my-1 mb-2" style={{ background: '#3B5998', color: 'white', borderRadius: 5 }}>{item.TTPNumber}</span>}
                </div>
                <img className='item-image-small ml-auto' src={getImageUrl(item.image)} />
            </div>
            <Button variant="outline-danger ml-2 mt-2" size="sm" onClick={() => props.onRemoveClick(item)}>remove</Button>
        </div>
    )
}
